import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ProviderSidebarComponent } from '../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { MyRequestSharedComponent } from '../../shared/components/my-request-shared/my-request-shared.component';

@Component({
  selector: 'app-provider-my-request',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
    MyRequestSharedComponent,
  ],
  templateUrl: './my-request.component.html',
  styleUrl: './my-request.component.scss',
})
export class ProviderMyRequestComponent {}
